export const ROUTES = {
  INDEX: '/',
  MODELS: '/models',
  COLOURS: '/colours/:trimCode/:modelCode',
  ACCESSORIES: '/accessories/:trimCode/:modelCode',
  SUMMARY: '/summary/:trimCode/:modelCode',
};
